import script from "./Calling-C2CVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Calling-C2CVideo.vue?vue&type=script&setup=true&lang=ts"

import "./Calling-C2CVideo.vue?vue&type=style&index=0&id=93273570&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93273570"]])

export default __exports__